'use strict'

// ////////////////////////////////////////////////////////////////
//   快速表格定义
// ///////////////////////////////////////////////////////////////
import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawTxt,
    _drawHline,
    _drawVline,
    _drawBegin,
    _drawEnd
} from './cl.draw'
import {
    CHART_LAYOUT,
} from '../cl.chart.res'
import {
    formatMoney,
    formatVolume,
    formatPrice,
    formatFloat,
    formatInteger,
    formatMsecMinute,
    copyJsonOfDeep,
    updateJsonOfDeep,
    offsetRect,
    sortNumberArray,
    sortStringArray,
    changeSortMode
} from '../cl.utils'
import {
    initCommonInfo,
    checkLayout
} from './cl.chart.init'

import ClDrawCursor from './cl.draw.cursor'

import { getValue } from '../datas/cl.data'

export default class ClChartTable {
    /**
  
     * Creates an instance of ClChartLine.
     * @param {Object} father line chart's parent context
     */
    constructor(father) {
        initCommonInfo(this, father)

        this.dataLayer = father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo
        //   console.log('this.linkInfo', this.linkInfo.curKey);
        //   this.keyInfo = this.father.dataLayer.keyInfo
        //   this.data = {}
    }
    init(cfg, callback) {
        this.callback = callback
        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 200,
            height: 300
        }
        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        this.config = copyJsonOfDeep(cfg.config)
        // this.config = updateJsonOfDeep(cfg.config, CHART_TABLE)

        this.tableInfo = cfg.tableInfo
        // console.log(this.tableInfo);
        
        // 这里补充信息
        for (let i = 0; i < this.tableInfo.length; i++) {
            if (this.tableInfo[i].getvar === undefined) {
                this.tableInfo[i].getvar = 'getFltVar'
            }
            if (this.tableInfo[i].getclr === undefined) {
                this.tableInfo[i].getclr = 'getFltClr'
            }
            if (this.tableInfo[i].align === undefined) {
                this.tableInfo[i].align = 'right'
            }
            if (this.tableInfo[i].sort === undefined) {
                this.tableInfo[i].sort = 'sort'
            }
        }
        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 初始化子窗口
        this.childDraws = {}
        this.setChildDraw()
        this.config.fieldlock = Math.min(this.config.fieldlock, this.tableInfo.length - 1)
        this.config.fieldmins = Math.max(this.config.fieldmins, this.config.fieldlock + 1)
        this.drawInfo = {
            cursorIndex: -1, // 鼠标所在的记录索引 需要根据数据来定位
            pageRecs: -1, // 每页记录数
            pageCount: -1, // 全部页数
            pageIndex: -1, // 当前页索引
            maxBeginIdx: 0,

            selectIndex: this.linkInfo.selectIndex === undefined ? -1 : this.linkInfo.selectIndex, // 当前选中的记录索引 需要根据初始化信息来定位
            beginFieldsIdx: this.linkInfo.beginFieldsIdx || this.config.fieldlock, // 当前字段左移索引数
            beginIdx: this.linkInfo.beginIdx || 0, // 当前页面开始记录
            sortFieldIdx: this.linkInfo.sortFieldIdx || -1,
            sortFieldMode: this.linkInfo.sortFieldMode || 'preface',
        }
        this.readyDraw()
        // console.log(this.tableInfo, this.drawInfo);
    }
    changeTlabel(index, value, israte) {
        if (this.tableInfo[index]) {
            this.tableInfo[index].label = String(value)
            if (israte) {        
                this.tableInfo[index].label = formatPrice(value * 100, 2) + '%';
                if (value > 0.00001) {
                    this.tableInfo[index].tclr = this.color.red
                }
                else if (value < -0.00001) {
                    this.tableInfo[index].tclr = this.color.green
                }
            }
        }
        // console.log(this);  
    }
    checkConfig() { // 检查配置有冲突的修正过来
        checkLayout(this.layout)

        this.config.header.pixel *= this.scale;
        this.config.header.spaceX *= this.scale;
        this.config.header.spaceY *= this.scale;
        this.config.record.pixel *= this.scale;
        this.config.record.spaceX *= this.scale;
        this.config.record.spaceY *= this.scale;
        if (this.config.header.spaceX < this.config.record.spaceX) {
            this.config.header.spaceX = this.config.record.spaceX
        }
        this.numLen = _getTxtWidth(this.context, '8', this.config.record.font, this.config.record.pixel)

        this.config.header.height = this.config.header.pixel + 2 * this.config.header.spaceY + this.scale;
        this.config.record.height = this.config.record.pixel + 2 * this.config.record.spaceY + this.scale;

    }
    setPublicRect() {
        this.rectChart = offsetRect(this.rectMain, this.layout.margin)
        // 计算title和mess矩形位置
        this.rectTitle = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectMess = {
            left: this.rectChart.left,
            top: this.rectChart.top,
            width: 0,
            height: 0
        }
        if (this.config.header.display !== 'none') {
            this.rectTitle = {
                left: this.rectChart.left,
                top: this.rectChart.top,
                width: this.rectChart.width,
                height: this.config.header.height
            }
            this.rectMess = {
                left: this.rectChart.left,
                top: this.rectChart.top + this.config.header.height,
                width: this.rectChart.width,
                height: this.rectChart.height - this.config.header.height,
            }
        } else {
            this.rectTitle = {
                left: 0,
                top: 0,
                width: 0,
                height: 0
            }
            this.rectMess = {
                left: this.rectChart.left,
                top: this.rectChart.top,
                width: this.rectChart.width,
                height: this.rectChart.height,
            }
        }
    }
    setChildDraw() {
        this.childDraws['CURSOR'] = new ClDrawCursor(this, {
            rectMain: this.rectMess,
            rectChart: this.rectChart,
            style: 'horline'
        })
    }
    moveFields(moveIndex) {
        moveIndex = Math.floor(moveIndex)
        // console.log(moveIndex, this.drawInfo.beginFieldsIdx, this.config.fieldmins, this.config.fieldlock);
        if (moveIndex < 0) {
            if (this.drawInfo.beginFieldsIdx > this.config.fieldlock) {
                this.drawInfo.beginFieldsIdx += moveIndex
                if (this.drawInfo.beginFieldsIdx < this.config.fieldlock) {
                    this.drawInfo.beginFieldsIdx = this.config.fieldlock
                }
            }
        }
        if (moveIndex > 0) {
            const maxFieldIdx = this.config.fieldlock + this.tableInfo.length - this.config.fieldmins
            if (this.drawInfo.beginFieldsIdx < maxFieldIdx) {
                this.drawInfo.beginFieldsIdx += moveIndex
                if (this.drawInfo.beginFieldsIdx > maxFieldIdx) {
                    this.drawInfo.beginFieldsIdx = maxFieldIdx
                }
            }
        }
        this.linkInfo.beginFieldsIdx = this.drawInfo.beginFieldsIdx
        // console.log(moveIndex, this.drawInfo.beginFieldsIdx, this.tableInfo.length);
        this.readyDraw()
        this.onPaint()
    }
    moveRecord(moveIndex) {
        moveIndex = Math.floor(moveIndex)
        if (moveIndex === 0) {
            return
        }
        if (moveIndex < 0) {
            if (this.drawInfo.beginIdx > 0) {
                this.drawInfo.beginIdx += moveIndex
                if (this.drawInfo.beginIdx < 0) {
                    this.drawInfo.beginIdx = 0
                }
                this.linkInfo.beginIdx = this.drawInfo.beginIdx
            }
        }
        if (moveIndex > 0) {
            if (this.drawInfo.beginIdx < this.drawInfo.maxBeginIdx) {
                this.drawInfo.beginIdx += moveIndex
                if (this.drawInfo.beginIdx > this.drawInfo.maxBeginIdx) {
                    this.drawInfo.beginIdx = this.drawInfo.maxBeginIdx
                }
            }
        }
        this.linkInfo.beginIdx = this.drawInfo.beginIdx
        // this.readyData()
        this.readyDraw()
        this.onPaint()
    }
    onKeyDown(event) {
        // console.log(event)
        switch (event.keyCode) {
            case 38: // up
                if (this.drawInfo.selectIndex <= this.drawInfo.beginIdx) {
                    this.moveRecord(-1)
                }
                if (this.drawInfo.selectIndex > this.drawInfo.beginIdx) {
                    this.changeSelect(this.drawInfo.selectIndex - 1, true)
                }
                
                break
            case 40: // down
                console.log(this.drawInfo.pageRecs, this.drawInfo.selectIndex, this.drawInfo.beginIdx);
                if (this.drawInfo.selectIndex - this.drawInfo.beginIdx >= this.drawInfo.pageRecs - 1) {
                    this.moveRecord(1)
                }
                if (this.drawInfo.selectIndex - this.drawInfo.beginIdx < this.drawInfo.pageRecs - 1) {
                    this.changeSelect(this.drawInfo.selectIndex + 1, true)
                }
                break
            case 37: // left
                this.moveFields(-1)
                break
            case 39: // right
                this.moveFields(1)
                break
        }
    }
    onMouseOut(event) {
        this.childDraws['CURSOR'].onClear()
    }
    getMouseXIndex(mousePos) {
        if (mousePos.y <= this.rectMess.top) {
            return 0
        } else {
            let yy = mousePos.y - this.rectMess.top
            let index = Math.floor(yy / this.config.record.height)
            if (index > this.drawInfo.pageRecs - 1) {
                index = this.drawInfo.pageRecs - 1
            }
            if (index > this.drawInfo.maxDataNums - 1) {
                index = this.drawInfo.maxDataNums - 1
            }
            return index
        }
    }
    getMouseInFieldIndex(mousePos) {

        if ((mousePos.x < this.rectTitle.left) || (mousePos.x > this.rectTitle.left + this.rectTitle.width) ||
            (mousePos.y < this.rectTitle.top) || (mousePos.y > this.rectTitle.top + this.rectTitle.height)) {
            return -1
        } else {
            let moveX = this.rectTitle.left;
            for (let i = 0; i < this.tableInfo.length; i++) {
                if (i < this.drawInfo.beginFieldsIdx && i >= this.config.fieldlock) {
                    continue
                }
                const stepX = this.tableInfo[i].width + 2 * this.drawInfo.spaceX;
                if (mousePos.x > (moveX) && mousePos.x < (moveX + stepX)) {
                    return i
                }
                moveX += stepX + this.scale;
                if (moveX > this.rectTitle.left + this.rectTitle.width) {
                    break
                }
            }
            return -1
        }
    }
    onMouseMove(event) {
        // 找到X坐标对应的数据索引
        this.drawInfo.mousePos = event.mousePos
        const valueY = this.rectMess.top + this.config.record.height * (this.getMouseXIndex(this.drawInfo.mousePos) + 1)
        if (valueY < this.rectMess.top + this.rectMess.height) {
            this.childDraws['CURSOR'].onPaint(this.drawInfo.mousePos, 0, valueY)
        }
    }
    changeSelect(newIndex, sendMsg) {
        // console.log(newIndex, this.drawInfo.selectIndex);
        if (newIndex >= 0 && newIndex < this.drawInfo.maxDataNums) {
            this.drawSelected(this.drawInfo.selectIndex, false)
            this.drawInfo.selectIndex = newIndex
            this.drawSelected(this.drawInfo.selectIndex, true)
    
            this.linkInfo.selectIndex = this.drawInfo.selectIndex
            // const curInfo = this.drawInfo.showInfo[this.drawInfo.selectIndex - this.drawInfo.beginIdx]
            // const curKey = curInfo[this.config.curKeyIdx].text
            if (sendMsg) {
                const curdata = this.getData()
                const curKey = getValue(curdata, this.tableInfo[this.config.curKeyIdx].field, this.drawInfo.selectIndex)
                this.callback({
                    event: 'changeselect',
                    curCode: curKey
                })
            }
            
            // console.log(this.drawInfo.selectIndex, curInfo[this.config.curKeyIdx].text);
        }
    }
    onClick(event) {
        this.drawInfo.mousePos = event.mousePos
        const fielsIdx = this.getMouseInFieldIndex(this.drawInfo.mousePos)

        if (fielsIdx >= 0) {
            // console.log(this.tableInfo[fielsIdx].style);
            if (this.tableInfo[fielsIdx].style === 'click') {
                this.callback({
                    label: this.tableInfo[fielsIdx].label,
                    left: this.tableInfo[fielsIdx].left,
                    top: this.rectMess.top + this.scale,
                    event: 'headclick',
                })
            } else {
                if (this.drawInfo.sortFieldIdx === fielsIdx) {
                    this.drawInfo.sortFieldMode = changeSortMode(this.drawInfo.sortFieldMode)
                } else {
                    this.drawInfo.sortFieldIdx = fielsIdx
                    this.drawInfo.sortFieldMode = 'descending'
                }
                this.linkInfo.sortFieldIdx = this.drawInfo.sortFieldIdx;
                this.linkInfo.sortFieldMode = this.drawInfo.sortFieldMode;
                this.onPaint()
            }
        } else {
            const newIndex = this.getMouseXIndex(this.drawInfo.mousePos) + this.drawInfo.beginIdx
            // console.log(newIndex);
            if (newIndex !== this.drawInfo.selectIndex) {
                this.changeSelect(newIndex, true)
            }
            else {
                const curdata = this.getData()
                const curKey = getValue(curdata, this.tableInfo[this.config.curKeyIdx].field, this.drawInfo.selectIndex)
                this.callback({
                    event: 'click',
                    curCode: curKey
                })
            }
        }
        // console.log(event, this.drawInfo.selectIndex, this.drawInfo.beginIdx);
        // this.onPaint()
    }
    onDbClick(event) {
        // console.log(event);
        // const curInfo = this.drawInfo.showInfo[this.drawInfo.selectIndex - this.drawInfo.beginIdx]
        // if (this.drawInfo.selectIndex < 0) {
        //     this.onClick(event)
        // }
        if (this.drawInfo.selectIndex >= 0) {

            const curInfo = this.drawInfo.showInfo[this.drawInfo.selectIndex - this.drawInfo.beginIdx]
            // console.log(this.drawInfo.selectIndex, this.drawInfo.showInfo.length, curInfo);
            this.callback({
                event: 'dataclick',
                curCode: curInfo[this.config.curKeyIdx].text
            })
        }
        // 向上级传递 Enter 信息
    }
    onMouseWheel(event) {
        // console.log('onMouseWheel', event.deltaX, event.deltaY, Math.abs(event.deltaX), Math.abs(event.deltaY))
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            if (Math.abs(event.deltaX) > 0) {
                let moveI = Math.abs(event.deltaX) > 10 ? event.deltaX / 10 : (event.deltaX > 1 ? 1 : event.deltaX < -1 ? -1 : 0)
                // let moveI = Math.abs(event.deltaX) >= 10 ? event.deltaX / 10 : event.deltaX / 3
                this.moveFields(moveI)
            }
        } else {
            if (Math.abs(event.deltaY) > 0) {
                let moveI = Math.abs(event.deltaY) > 30 ? event.deltaY : (Math.abs(event.deltaY) > 10 ? event.deltaY / 10 : (event.deltaY > 0 ? 1 : -1))
                // console.log('onMouseWheel', moveI, event.deltaX, event.deltaY)
                this.moveRecord(moveI)
            }
        }
    }
    drawClear() {
        _fillRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height, this.color.back)
        _drawBegin(this.context, this.color.grid)
        _drawRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
        _drawEnd(this.context)
    }
    drawGrid() {
        _drawBegin(this.context, this.color.grid);
        _fillRect(this.context, this.rectTitle.left, this.rectTitle.top, this.rectTitle.width, this.rectTitle.height, this.color.header)
        _drawHline(this.context, this.rectTitle.left, this.rectTitle.left + this.rectTitle.width, this.rectTitle.top + this.config.header.height - this.scale)

        let moveX = this.rectMess.left + this.drawInfo.spaceX;
        for (let i = 0; i < this.tableInfo.length; i++) {
            if (i < this.drawInfo.beginFieldsIdx && i >= this.config.fieldlock) {
                continue
            }
            moveX += this.tableInfo[i].width + this.drawInfo.spaceX;
            if (moveX > this.rectMess.left + this.rectMess.width) {
                moveX = this.rectMess.left + this.rectMess.width - this.scale
            }
            // console.log(this.drawInfo.stopFieldsIdx, i, moveX);
                
            _drawVline(this.context, moveX + this.scale, this.rectMain.top, this.rectMain.top + this.rectMain.height)

            moveX += this.scale + this.drawInfo.spaceX;
            // if (moveX > this.rectMain.left + this.rectMain.width) {
            //     break
            // }
            
        }
        let moveY = this.rectMess.top;
        for (let k = 0; k < this.drawInfo.pageRecs; k++) {
            moveY += this.config.record.height;
            _drawHline(this.context, this.rectMess.left, this.rectMess.left + this.rectMess.width, moveY - this.scale)
        }
        _drawEnd(this.context);
    }
    drawScroll() {
        // _fillRect(this.context, this.rectChart.left, this.rectChart.top, this.rectChart.width, this.rectChart.height, this.color.back)
    }
    drawTitle() {
        let moveX = this.rectTitle.left + this.drawInfo.spaceX;
        let moveY = this.rectTitle.top + this.config.header.spaceY;

        _drawBegin(this.context, this.color.header);

        for (let i = 0; i < this.tableInfo.length; i++) {
            if (i < this.drawInfo.beginFieldsIdx && i >= this.config.fieldlock) {
                continue
            }
            let showX = 0;
            const showW = _getTxtWidth(this.context, this.tableInfo[i].label, this.config.header.font, this.config.header.pixel)
            // 这里可以检查长度是否超过 width 如果超出需要缩小字体大小
            if (this.tableInfo[i].align !== 'left') {

                if (this.tableInfo[i].align === 'center') {
                    showX += (this.tableInfo[i].width - showW) / 2;
                } else {
                    showX += this.tableInfo[i].width - showW;

                }
            }
            let clr = this.color.txt
            if (this.tableInfo[i].tclr !== undefined) {
                clr = this.tableInfo[i].tclr
            }
            else {
                if (this.drawInfo.sortFieldIdx === i) {
                    if (this.drawInfo.sortFieldMode === 'ascending') {
                        clr = this.color.green
                    }
                    if (this.drawInfo.sortFieldMode === 'descending') {
                        clr = this.color.red
                    }
                }
            }
            this.tableInfo[i].left = moveX + showX
            // console.log('object,', this.tableInfo[i].label, moveX + showX, moveY);
            _drawTxt(this.context, moveX + showX, moveY, this.tableInfo[i].label,
                this.config.header.font, this.config.header.pixel, clr);
            moveX += this.tableInfo[i].width + this.drawInfo.spaceX + this.scale + this.drawInfo.spaceX;
            if (this.drawInfo.stopFieldsIdx >= 0 && i >= this.drawInfo.stopFieldsIdx) {
                break
            }
        }
        _drawEnd(this.context);

    }
    drawRecord(moveX, moveY, ridx, fidx) {
        let showX = 0;
        const curInfo = this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx][fidx]
        // console.log(curInfo);
        const showW = _getTxtWidth(this.context, curInfo.text, this.config.record.font, this.config.record.pixel)
        // 这里可以检查长度是否超过 width 如果超出需要缩小字体大小
        if (this.tableInfo[curInfo.fidx].align !== 'left') {
            if (this.tableInfo[curInfo.fidx].align === 'center') {
                showX += (this.tableInfo[curInfo.fidx].width - showW) / 2;
            } else {
                showX += this.tableInfo[curInfo.fidx].width - showW;
            }
        }
        // console.log('object,', i, k, this.drawInfo.showInfo[k]);
        _drawTxt(this.context, moveX + showX, moveY + this.config.record.spaceY, curInfo.text,
            this.config.record.font, this.config.record.pixel, curInfo.color);

    }
    drawSelected(ridx, selected) {
        if (ridx < 0) {
            return
        }
        const curidx = ridx - this.drawInfo.beginIdx
        if (curidx < 0 || curidx > this.drawInfo.showInfo.length - 1) {
            return
        }
        const moveY = this.rectMess.top + this.config.record.height * (ridx - this.drawInfo.beginIdx)
        // console.log('====', ridx, this.drawInfo.selectIndex, this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx]);
        _fillRect(this.context, this.rectMess.left, moveY, this.rectMess.width - this.scale, this.config.record.height - this.scale, selected ? this.color.select : this.color.back)
        _drawBegin(this.context, this.color.grid);
        let moveX = this.rectMess.left + this.drawInfo.spaceX;
        // console.log(this.rectMess.left, this.rectTitle.left);
        for (let fidx = 0; fidx < this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx].length; fidx++) {
        
            this.drawRecord(moveX, moveY, ridx, fidx)

            const curInfo = this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx][fidx]
            moveX += this.tableInfo[curInfo.fidx].width + this.drawInfo.spaceX;
            if (moveX > this.rectMess.left + this.rectMess.width) {
                moveX = this.rectMess.left + this.rectMess.width - this.scale
            }
            // console.log(this.drawInfo.stopFieldsIdx, fidx, moveX, this.rectMess.left + this.rectMess.width);

            _drawVline(this.context, moveX + this.scale, moveY, moveY + this.config.record.height)
            moveX += this.scale + this.drawInfo.spaceX;
        }
        _drawEnd(this.context);
    }
    drawTable() {
        // console.log('====', this.drawInfo.showInfo);

        _drawBegin(this.context, this.color.grid);
        let moveY = this.rectMess.top;
        for (let ridx = this.drawInfo.beginIdx; ridx < this.drawInfo.beginIdx + this.drawInfo.pageRecs && ridx < this.drawInfo.maxDataNums; ridx++) {
            let moveX = this.rectMess.left + this.drawInfo.spaceX;
            if (ridx === this.drawInfo.selectIndex) {
                this.drawSelected(ridx, true)
            } else {
                for (let fidx = 0; fidx < this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx].length; fidx++) {
                    const curInfo = this.drawInfo.showInfo[ridx - this.drawInfo.beginIdx][fidx]
                    this.drawRecord(moveX, moveY, ridx, fidx)
                    moveX += this.tableInfo[curInfo.fidx].width + this.drawInfo.spaceX + this.scale + this.drawInfo.spaceX;
                }
            }
            moveY += this.config.record.height;
        }
        _drawEnd(this.context);
    }
    onPaint() {
        _setLineWidth(this.context, this.scale)
        this.drawClear() // 清理画图区

        this.readyData()

        this.drawGrid() // 画线格

        // this.drawScroll() // 画滚动块    

        this.drawTitle() // 画标题  
        this.drawTable() // 画表格  


        // this.drawGrid() // 画线格
        // this.img = _getImageData(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
    }
    readyDraw() {

        // 计算长宽信息
        let curww = 0;
        // const font = this.config.header.font > this.config.record.font ? this.config.header.font : this.config.record.font;
        const hfont = this.config.header.font
        const pixel = this.config.header.pixel > this.config.record.pixel ? this.config.header.pixel : this.config.record.pixel;

        this.drawInfo.stopFieldsIdx = -1
        const minww = this.config.maxchs * this.numLen;
        let useFields = 0
        for (let i = 0; i < this.tableInfo.length; i++) {
            // console.log(this.tableInfo[i].maxchs);
            if (i < this.drawInfo.beginFieldsIdx && i >= this.config.fieldlock) {
                continue
            }
            if (this.tableInfo[i].maxchs === undefined) {
                this.tableInfo[i].width = _getTxtWidth(this.context, this.tableInfo[i].label, hfont, pixel);
                this.tableInfo[i].width = this.tableInfo[i].width > minww ? this.tableInfo[i].width : minww;
            } else {
                this.tableInfo[i].width = this.tableInfo[i].maxchs * this.numLen;
            }
            const incrw = this.tableInfo[i].width + 2 * this.config.header.spaceX
            // console.log(curww, incrw, this.rectMain.width, useFields, this.drawInfo.stopFieldsIdx);
        
            if (curww + incrw > this.rectMain.width) {
                if (i === 0) {
                    this.drawInfo.stopFieldsIdx = 0;
                    this.tableInfo[i].width = this.rectMain.width - 2 * this.config.header.spaceX
                }
                else {
                    this.drawInfo.stopFieldsIdx = i - 1;
                }
                break
            }
            useFields++
            curww += incrw;
        }
        // console.log(this.config.header.spaceX, this.config.autoexpand, this.drawInfo.stopFieldsIdx, curww, useFields, this.drawInfo.stopFieldsIdx);
        if (this.drawInfo.stopFieldsIdx >= 0 || this.config.autoexpand) {
            this.drawInfo.spaceX = this.config.header.spaceX + (this.rectMess.width - curww) / (2 * (useFields + 1))
        } else {
            this.drawInfo.spaceX = this.config.header.spaceX;
        }
        this.drawInfo.pageRecs = Math.floor(this.rectMess.height / this.config.record.height);
        // this.config.autoexpand
        // console.log('--', this.drawInfo.spaceX, this.drawInfo.pageRecs);       
    }
    getData() {
        this.data = this.father.getData(this.hotKey)
        if (this.data === undefined) return false;
        // let curdata = copyJsonOfDeep(this.data)
        let curdata = this.data
        // 这里根据排序方式进行数据调整
        if (!(this.drawInfo.sortFieldIdx < 0 || this.drawInfo.sortFieldMode === undefined)) {
            // console.log('----', this.drawInfo, this.tableInfo[this.drawInfo.sortFieldIdx].sort);
            if (this.tableInfo[this.drawInfo.sortFieldIdx].sort === 'resume' || this.drawInfo.sortFieldMode === 'preface') {
                this.drawInfo.sortFieldIdx = -1
                this.drawInfo.sortFieldMode = 'preface'
            } else {
                curdata = copyJsonOfDeep(this.data)
                // console.log('--1--', this.tableInfo[this.drawInfo.sortFieldIdx].field, curdata.fields, this.data);
                const realIndex = curdata.fields[this.tableInfo[this.drawInfo.sortFieldIdx].field]
                if (this.tableInfo[this.drawInfo.sortFieldIdx].sort === 'string') {

                    sortStringArray(curdata.value, realIndex, this.drawInfo.sortFieldMode)
                } else {
                    sortNumberArray(curdata.value, realIndex, this.drawInfo.sortFieldMode)
                }
                // console.log('--2--', curdata.value.slice(0, 10));
            }
        }
        return curdata
    }
    initSelectIndex(curdata) {
        if (this.linkInfo.curKey === undefined || this.config.curKeyIdx === undefined) {
            return
        }
        for (let index = 0; index < this.drawInfo.showInfo.length; index++) {
            let curv = this.drawInfo.showInfo[index][this.config.curKeyIdx]
            if (curv === undefined) {
                this.config.curKeyIdx = 0
                curv = this.drawInfo.showInfo[index][0]
            }
            // console.log(curv)//, curdata.value[curv.ridx][this.config.curKeyIdx]) //, curv[this.config.curKeyIdx].index, curdata.value[curv.index], this.config, this.linkInfo);
            if (curdata.value[curv.ridx][this.config.curKeyIdx] === this.linkInfo.curKey) {
                this.drawInfo.selectIndex = curv.ridx
            }
        }
        // console.log(this.drawInfo.selectIndex)
    }
    changeSelectIndex(newKey) {
        if (this.config.curKeyIdx === undefined) {
            return
        }
        let newIndex = -1
        const curdata = this.getData()
        for (let index = 0; index < curdata.value.length; index++) {
            let curkey = getValue(curdata, this.tableInfo[this.config.curKeyIdx].field, index)
            // console.log(index, curkey, newKey);
            if (curkey === newKey) {
                newIndex = index
                break
            }
        }
        if (newIndex === -1) return
        // console.log(newIndex, this.drawInfo.selectIndex, this.drawInfo.beginIdx, this.drawInfo.pageRecs)
        if (newIndex < this.drawInfo.beginIdx || newIndex >= this.drawInfo.beginIdx + this.drawInfo.pageRecs)
        {
            // 这里需要改变定位
            let topIdx = Math.floor(newIndex / this.drawInfo.pageRecs) * this.drawInfo.pageRecs
            if (topIdx + this.drawInfo.pageRecs > curdata.value.length) {
                topIdx = curdata.value.length - this.drawInfo.pageRecs
            }
            this.drawInfo.beginIdx = topIdx < 0 ? 0 : topIdx
            // console.log(newIndex, this.drawInfo.selectIndex, this.drawInfo.beginIdx, this.drawInfo.pageRecs)
            
            this.drawInfo.selectIndex = newIndex
            this.linkInfo.selectIndex = this.drawInfo.selectIndex
           
            this.readyDraw()
            this.onPaint()
        }
        else {
            this.changeSelect(newIndex, false);
        }
        // console.log(this.drawInfo.selectIndex)
    }
    getColor(curIndex, curKey, curVal) {
        let clr
        switch (this.tableInfo[curIndex].getclr) {
            case "getCodeClr":
                clr = this.color.code;
                break;
            case "getNameClr":
                clr = this.color.name;
                break;
            case "getIntClr":
                clr = this.color.yellow;
                break;
            case "getPrcClr":
                // 需要和前收盘做比较
                // console.log(this.keyInfo, this.keyInfo[curKey], curKey);
                if (this.keyInfo[curKey] !== undefined) {
                    const agop = this.keyInfo[curKey].static.agoprc
                    clr = curVal > agop ? this.color.red : (curVal < agop ? this.color.green : this.color.yellow)
                } else {
                    clr = this.color.yellow
                }
                break;
            case "getFltClr":
                clr = this.color.yellow;
                break;
            case "getOneClr":
                // console.log(val);
                clr = (curVal > 0.999999 || curVal < -0.999999) ? this.color.red : this.color.green
                break;
            case "getZeroClr":
                clr = curVal > 0.0000001 ? this.color.red : (curVal < -0.0000001 ? this.color.green : this.color.white)
                break;
            case "getRangeClr":
                if (this.tableInfo[curIndex].range !== undefined) {
                    clr = this.color.txt
                    if (curVal >= this.tableInfo[curIndex].range[1]) {
                        clr = this.color.red
                    }
                    if (curVal <= this.tableInfo[curIndex].range[0]) {
                        clr = this.color.green
                    }
                }
                break;
            case "getVolClr":
                clr = this.color.vol;
                break;
            case "getPosClr":
                clr = this.color.red;
                break;
            case "getNegClr":
                clr = this.color.green;
                break;
            default:
                clr = this.color.yellow;
        }
        return clr
    }
    getShowTxt(curIndex, val) {
        let showtxt = ''
        switch (this.tableInfo[curIndex].getvar) {
            case "getSrcVolVar":
                showtxt = formatVolume(val, 1);
                break;
            case "getVolVar":
                showtxt = formatVolume(val, 100);
                break;
            case "getMnyVar":
                showtxt = formatMoney(val, 100);
                break;
            case "getIntVar":
                showtxt = formatInteger(val, 1);
                break;
            case "getPrcVar":
                showtxt = formatPrice(val, 2);
                break;
            case "getMinuVar":
                showtxt = formatMsecMinute(val);
                break;
            case "getFltVar":
                showtxt = formatFloat(val, 3, this.config.maxchs);
                break;
            case "getPctVar":
                showtxt = formatPrice(val * 100, 2) + '%';
                break;
            case "getStrVar":
                showtxt = val
                break;
            default:
                showtxt = String(val);
                break;
        }
        return showtxt
    }
    readyData() {
        // 计算最大最小值等
        const curdata = this.getData()
        if (!curdata) {
            return;
        }
        if (this.keyInfo === undefined) {
            this.keyInfo = this.father.dataLayer.keyInfo
        }
        // console.log(curdata.value);
        // 下面计算基础的参数
        this.drawInfo.maxDataNums = curdata.value.length;
        this.drawInfo.pageCount = this.drawInfo.maxDataNums / this.drawInfo.pageRecs;
        this.drawInfo.pageIndex = 0
        this.drawInfo.maxBeginIdx = this.drawInfo.maxDataNums - this.drawInfo.pageRecs
        if (this.drawInfo.maxBeginIdx < 0) {
            this.drawInfo.maxBeginIdx = 0
        }
        // 这里要根据鼠标定位 cursorIndex 
        // 这里要根据默认代码定位 selectIndex 以确定开始的页数 pageIndex 然后可以确定 beginIdx
        // console.log(this.linkInfo)

        // 这里开始提取显示内容
        this.drawInfo.showInfo = [];

        let clr, val, showtxt;
        for (let k = this.drawInfo.beginIdx; k < this.drawInfo.beginIdx + this.drawInfo.pageRecs && k < this.drawInfo.maxDataNums; k++) {
            const curKey = getValue(curdata, this.tableInfo[this.config.curKeyIdx].field, k)
            // console.log('object', k, this.tableInfo[this.config.curKeyIdx].field, curKey, curdata.value.length);
            let showstr = [];
            for (let i = 0; i < this.tableInfo.length; i++) {
                if (i < this.drawInfo.beginFieldsIdx && i >= this.config.fieldlock) {
                    continue
                }
                if (this.drawInfo.stopFieldsIdx >= 0 && i > this.drawInfo.stopFieldsIdx) {
                    break
                }
                // for (let i = 0; i < this.tableInfo.length; i++) {                
                val = getValue(curdata, this.tableInfo[i].field, k);

                showtxt = this.getShowTxt(i, val)
                
                if (this.tableInfo[i].color !== undefined) {
                    clr = this.color[this.tableInfo[i].color]
                }
                else {
                    if (this.tableInfo[i].fieldclr !== undefined) {
                        clr = this.color[getValue(curdata, this.tableInfo[i].fieldclr, k)];
                        if (clr === '' || clr === '0' || clr === undefined) {
                            clr = this.getColor(i, curKey, val)
                        }
                    }
                    else {
                        clr = this.getColor(i, curKey, val)
                    }
                }
                showstr.push({
                    ridx: k,
                    fidx: i,
                    text: showtxt,
                    color: clr
                });
            }
            this.drawInfo.showInfo.push(showstr);
        }
        // console.log(this.drawInfo.selectIndex, this.linkInfo.curKey, curdata);
        if (this.drawInfo.selectIndex === -1) {
            this.initSelectIndex(curdata)
        }
    }
}